import type React from "react"

export const SidebarNavClose = (props: React.ComponentProps<"svg">): JSX.Element => (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M5.833 4.167v11.667m9.167-2.5L11.667 10 15 6.667'
            stroke='currentColor'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
)
